import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts';
import { ProfileResult } from '../../types/result';

interface Props {
  result: ProfileResult;
}

const ProfileCard: React.FC<Props> = ({ result }) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  return (
    <div className="bg-gradient-to-br from-scaleo-blue to-secondary rounded-2xl p-6 text-white" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Badge */}
      <div className="inline-block bg-white bg-opacity-20 rounded-full px-3 py-1 text-xs font-semibold mb-4">
        {t('result.code')} — {result.code}
      </div>

      {/* Name with Icon */}
      <div className="flex items-center gap-3 mb-3">
        <img
          src={`/icons/profiles/${result.code}.png`}
          alt={result.code}
          className="w-16 h-16 rounded-full shrink-0"
        />
        <h2 className="text-2xl font-bold leading-tight">
          {result.name}
        </h2>
      </div>

      {/* Tagline */}
      <div className="bg-white bg-opacity-15 rounded-xl px-4 py-3 mb-4">
        <p className="text-sm font-medium text-blue-50 leading-relaxed italic">
          "{result.tagline}"
        </p>
      </div>

      {/* Description */}
      <p className="text-sm text-blue-100 leading-relaxed">
        {result.description}
      </p>
    </div>
  );
};

export default ProfileCard;
